/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import type { ProcessorFactoryBuilder } from "@powerhousedao/reactor-browser";
import { codegenFactoryBuilder } from "./codegen/factory.js";
import { vetraReadModelFactoryBuilder } from "./vetra-read-model/factory.js";

export const processorFactoryBuilders: ProcessorFactoryBuilder[] = [
  vetraReadModelFactoryBuilder,
  codegenFactoryBuilder,
];
